import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { ACCESS_API } from "./apiRoutes";

interface UseGetPermissionByCommunityIdProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPermissionByCommunityId = async (communityId: string) =>
  await axiosAuth.get(`${ACCESS_API}/community/${communityId}`);

const useGetPermissionByCommunityId = ({
  communityId,
  queryParams,
}: UseGetPermissionByCommunityIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["permission", communityId],
    queryFn: () => getPermissionByCommunityId(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetPermissionByCommunityId;
